import { Component } from "solid-js"
import { Spinner, SpinnerType } from "solid-spinner"
import "../assets/page-loading.css";

export const PageLoading : Component = () => {
    return (
        <>
            <div class="loading-container">
                <Spinner type={SpinnerType.bars} color="#696969" width={"6rem"} height={"6rem"} />
            </div>
        </>
    )
}